export default "__VITE_ASSET__BDtBxr4b__"